import { forwardRef } from "react";
import { ScopeOfWorkProvider } from "../context/ScopeOfWorkContext";
import { ScopeOfWorkController } from "../controller/ScopeOfWorkController";
import { ScopeOfWorkHandle } from "../controller/scope-of-work.handle";
import { ScopeOfWorkState, ScopeOfWorkStep } from "../context/scope-of-work.types";

export interface ScopeOfWorkViewProps {
  onStateChange?: (state: ScopeOfWorkState) => void;
  onStepChange?: (step: ScopeOfWorkStep, isLastStep: boolean) => void;
  initialPayload?: Partial<ScopeOfWorkState>;
  showControls?: boolean;
  debugJsonPayload?: boolean;
  lockCategory?: boolean;
  showSummary?: boolean;
  job?: any;
  jobAlias?: string;
  setJobAlias?: (val: string) => void;
  jobDescription?: string;
  setJobDescription?: (val: string) => void;
}

export const ScopeOfWorkView = forwardRef<ScopeOfWorkHandle, ScopeOfWorkViewProps>(
  (
    {
      lockCategory = false,
      onStateChange,
      onStepChange,
      initialPayload,
      showControls = false,
      debugJsonPayload = false,
      showSummary = false,
      job,
      jobAlias,
      setJobAlias,
      jobDescription,
      setJobDescription,
    },
    ref,
  ) => {
    return (
      <ScopeOfWorkProvider initialPayload={initialPayload}>
        <ScopeOfWorkController
          ref={ref}
          onStateChange={onStateChange}
          onStepChange={onStepChange}
          showControls={showControls}
          debugJsonPayload={debugJsonPayload}
          lockCategory={lockCategory}
          showSummary={showSummary}
          job={job}
          jobAlias={jobAlias}
          setJobAlias={setJobAlias}
          jobDescription={jobDescription}
          setJobDescription={setJobDescription}
        />
      </ScopeOfWorkProvider>
    );
  },
);
